import { api_configuration } from "../../../common";
import messages = require("../../front/messages");
import api_cs = api_configuration.types.client_state.alan_api;
import { removeFilesFromUploadQueue } from "./fileUpload";
import * as discard from "./discard";
import { deleteCollectionEntry } from "./delete";

export function entry(node: api_cs.Cnode): void {
	removeFilesFromUploadQueue(node);
	const entity = node.input.entity().variant;
	switch (entity.name) {
		case "root":
			discard.entity(entity.definition.properties.root);
			break;
		case "entry":
			switch (entity.definition.properties.location.state.name) {
				case "remote":
					discard.entity(entity.definition.properties.node);
					break;
				case "local":
					deleteCollectionEntry(entity.definition);
			}
	}
	messages.removeAllMessages();
}
